import { useFeatureIsOn } from 'src/common/growthbook';
import { B2BUserHelper } from 'src/common/helpers';
import type { UserData } from 'src/common/interfaces';
import type { CompanyData } from 'src/common/interfaces/companies';
import { type CompanyFeatureName, isFeatureEnabled } from 'src/common/utils/company-features';

export const useUserCompanyFeature = (featureName: CompanyFeatureName, user?: UserData['user']): boolean => {
  const isTeamsPlanEnabled = useFeatureIsOn('business-teams-checkout');

  // For logged out users / FF disabled
  if (!user || !isTeamsPlanEnabled) return true;

  const activeCompany = user.companies?.find((company) => !company.isDeadlinePassed);
  const activeSubscription = user.subscriptions?.find((sub) => sub?.type === 'company' && sub?.status === 'active');

  // For premium B2C users
  if (!activeCompany && !activeSubscription) return true;

  // Priority: Company features (if admin) > Subscription features (if has active subscription)
  let features: CompanyData['features'] | null | undefined;
  const b2bHelper = B2BUserHelper(user);

  if (b2bHelper.isCompanyAdmin && activeCompany?.features) {
    features = activeCompany.features as CompanyData['features'];
  } else if (activeSubscription?.features) {
    features = activeSubscription.features as CompanyData['features'];
  }

  return isFeatureEnabled(features, featureName);
};
